<template>
    <div class="home">
        <div class="content" v-if="ccurrentScreen === 'start'">
            <div style="color:black;font-size:10rem;font-weight: bold;text-align: center;">数学研学</div>
        </div>
        <div style="font-size:7rem;font-weight: bold;margin-top: 90px;z-index:999" v-if="ccurrentScreen === 'start'" @click="ccurrentScreen = 'gameRule'">开始游戏</div>
        <div class="gameRule" v-if="ccurrentScreen === 'gameRule'">
            <div style="width:100%;height:100%;position: relative;">
                <div style="position: absolute;;background-color: #FFFFFF;opacity: 0.7;width: 80%;height: 55%;top: 10rem;left: 10%;
                border-radius: 15px;"></div>
                <div class="ruleDetail">
                    <div style="font-size: 4rem;font-weight: bold;margin: 10px 0;">游戏规则</div>
                    <div>
                    <div style="font-size:2.5rem">1. 随机产生5道题目，请您按照指定手势或姿态，<b>无接触屏幕</b>进行答题</div>
                    <div style="font-size:2.5rem">2. 指定手势与姿态</div>
                    <div style="font-size:2.5rem"><b>选择题</b>：请将手掌停留到正确选项对应区域，停留3秒即为确定答案</div>
                    <div style="font-size:2.5rem"><b>判断题</b>：如果答案正确，请您将双手摆出“√”，错误则请您将双手摆出“×” </div>
                    </div>
                    <div style="margin-top:8rem">
                    <div style="text-align: center;font-weight: bold;font-size: 2.5rem;">欢迎来到数字研学世界</div>
                    <div style="text-align: center;font-weight: bold;font-size: 2.5rem;">接下来一起用以下手势来开启新世界
                    </div>
                    </div>
                    <div style="width:5rem;height: 5rem;margin-top: 2rem;">
                    <img src="../static/gesture.png" alt="" style="width:100%;height:100%">
                    </div>
                </div>
            </div>
        </div>
        <van-swipe :loop="false" :show-indicators="false" :touchable="false" v-if="ccurrentScreen === 'ckSubject'" class="Judge1" ref="swipe"
            :duration="0" @change="onChange">
            <van-swipe-item v-for="item in subjectList" :key="item.id" class="qqq">
                <div class="subjectNum" @click="back()">第{{currentSub}}题</div>
                <div style="position:absolute;background-color: #FFFFFF;opacity: 0.7;width: 80%;height: 20rem;top:20rem;right: 10%;border-radius: 15px;"></div>
                <div class="subjectContent">
                    <div class="subjectType">{{ item.type == 'judge' ? '判断题':'选择题'}}:</div>
                    <div class="subject">{{ item.title}}</div>
                </div>
                <div style="width:100%;height:37rem"></div>
                <div class="option1" v-if="item.type == 'judge'">
                    <div v-for="(judgeoption,index1) in item.options" :key="index1"
                        @click="Correctjudge(item.answer,index1)" style="margin-right:1rem;font-size: 3rem;text-align: center;display: flex;
                        flex-direction: column;align-items: center;">
                        {{ judgeoption}}
                        <!-- 默认样式 -->
                        <div style="width:10rem;height:10rem;"
                            v-if="index1 == 0 && answered == false && item.type == 'judge'">
                            <img src="../static/whiteCross.png" style="width:100%;height:100%">
                        </div>
                        <div style="width:10rem;height: 10rem;" v-if="index1 == 1 && answered == false &&
                        item.type == 'judge'">
                            <img src="../static/whitetick.png" style="width:100%;height:100%">
                        </div>
                        <!-- 答案错误，正确答案为正确 -->
                        <div style="width:10rem;height: 10rem;"
                            v-if="index1 !== item.answer && answered == true && solution == false && index1 == 0">
                            <img src="../static/cross.png" style="width:100%;height:100%">
                        </div>
                        <div style="width:10rem;height: 10rem;"
                            v-if="index1 == item.answer && answered == true && solution == false && index1 == 1">
                            <img src="../static/tick.png" style="width:100%;height:100%">
                        </div>
                        <!-- 答案错误，正确答案为错误 -->
                        <div style="width:10rem;height: 10rem;"
                            v-if="index1 == item.answer && answered == true && solution == false && index1 == 0">
                            <img src="../static/greenCross.png" style="width:100%;height:100%">
                        </div>
                        <div style="width:10rem;height: 10rem;"
                            v-if="index1 !== item.answer && answered == true && solution == false && index1 == 1">
                            <img src="../static/redtick.png" style="width:100%;height:100%">
                        </div>
                        <!-- 答案正确 -->
                        <div style="width:10rem;height: 10rem;"
                            v-if="index1 == item.answer && answered == true && solution == true && index1 == 0">
                            <img src="../static/greenCross.png" style="width:100%;height:100%">
                        </div>
                        <div style="width:10rem;height: 10rem;"
                            v-if="index1 == item.answer && answered == true && solution == true && index1 == 1">
                            <img src="../static/tick.png" style="width:100%;height:100%">
                        </div>
                    </div>
                </div>
                <div class="option1" v-if="item.type == 'select'" >
                    <div v-for="(option,index) in item.options" :key="index" @click="Correctjudge(item.answer,index)"
                        style="margin-right:1rem;font-size: 3rem;text-align: center;display: flex;
                        flex-direction: column;align-items: center;">
                        {{option}}
                        <!-- 默认样式 -->
                        <div style="width:10rem;height: 10rem;" v-if="answered == false && item.type == 'select'">
                            <img :src="choiceAnswer == index?select2:select1" style="width:100%;height:100%">
                        </div>
                        <!-- <div style="width:10rem;height: 10rem;" v-if="answered == false && item.type == 'select'">
                            <img :src="choiceAnswer == 1?select2:select1" style="width:100%;height:100%">
                        </div>
                        <div style="width:10rem;height: 10rem;" v-if="answered == false && item.type == 'select'">
                            <img :src="choiceAnswer == 2?select2:select1" style="width:100%;height:100%">
                        </div> -->
                        <!-- 答案正确 -->
                        <div style="width:10rem;height: 10rem;"
                            v-if="index == item.answer && answered == true && solution == true">
                            <img src="../static/tick.png" style="width:100%;height:100%">
                        </div>
                        <!-- 答案错误。显示正确答案 -->
                        <div style="width:10rem;height: 10rem;"
                            v-if="index !== item.answer && answered == true && solution == false">
                            <img src="../static/cross.png" style="width:100%;height:100%">
                        </div>
                        <div style="width:10rem;height: 10rem;"
                            v-if="index == item.answer && answered == true && solution == false">
                            <img src="../static/tick.png" style="width:100%;height:100%">
                        </div>
                    </div>
                </div>
                <div style="margin-top:5rem;font-weight:bold;font-size: 2.5rem;" v-show="answered == false">{{ item.type == 'judge'
                    ?'请用以上姿态比出您的正确答案'
                    :'请将您的手势放在正确答案区域内'}}
                </div>
                <div style="margin-top:5rem;display: flex;align-items: center;flex-direction: column;"
                    v-show="answered == true && isIncorrenct == true">
                    <div style="font-weight:bold;text-align: center;font-size: 2.5rem;">很抱歉，答错了！</div>
                    <div style="font-weight:bold;text-align: center;font-size: 2.5rem;">请采用手势“往左滑”，切换至下一题。</div>
                </div>
                <div style="margin-top:5rem;display: flex;align-items: center;flex-direction: column;"
                    v-show="answered == true && isCorrenct == true">
                    <div style="font-weight:bold;text-align: center;font-size: 2.5rem;">恭喜你，答对啦！</div>
                    <div style="font-weight:bold;text-align: center;font-size: 2.5rem;">请采用手势“往左滑”，切换至下一题。</div>
                </div>
                <van-progress :percentage="(timerNum/3) *100" ref="progress" style="margin-top: 10rem;width: 100%;" :show-pivot="false" v-show="answered == false&& item.type == 'select'"/>
            </van-swipe-item>
        </van-swipe>
        <div class="reuslt" v-if="ckReuslt">
            <div style="width:100%;height:100%;position:relative">
                <div style="position:absolute;top: 10%;left: 10%;width: 80%;height: 80%;border-radius: 15px;
                background-color: #FFFFFF;opacity: 0.7"></div>
                <div class="reuslt_detail">
                    <div style="font-weight:bold;font-size: 7rem;text-align: center;margin-top: 20rem;">{{correctNum}}分</div>
                     <div style="font-weight:bold;font-size: 3.5rem;text-align: center;margin-top: 5rem;">击败了xx%的用户</div>
                </div>
            </div>
        </div>
        <div style="position: fixed;z-index: 105;bottom: 12rem;width:100%;height: 300px;">
            <mediapipe ref="mediapipeRef" :hands-listens="handsListens"
                :pose-listens="poseListens" :select-listens="3" @select="select" @back="back"
                @okay="okay" @right="right" @wrong="wrong">
            </mediapipe>
        </div>
        <div v-if="subjectList[currentIndex].type == 'select' && ccurrentScreen === 'ckSubject' && answered == false"
            class="selectOption">
            <!-- <div style="font-size: 7rem;font-weight: bold; " :style="choiceAnswer == 0?'color:red':'color:green'">A
            </div>
            <div style="font-size: 7rem;font-weight: bold; " :style="choiceAnswer == 1?'color:red':'color:green'">B
            </div>
            <div style="font-size: 7rem;font-weight: bold; " :style="choiceAnswer == 2?'color:red':'color:green'">C
            </div> -->
        </div>
        <!-- <van-count-down :time="3000" ref="countDown" :auto-start="false" @finish="finish" @change="change" v-show="false"/> -->
    </div>
</template>

<script>
import { Dialog, Swipe, SwipeItem,CountDown ,Progress} from 'vant';
import mediapipe from '@/views/components/mediapipe'
import { Toast } from 'vant';
import { getQuestionList } from "@/api/question";
export default {
    components: {
        [Dialog.name]: Dialog,
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
        [CountDown.name]: CountDown,
        [Progress.name]: Progress,
        mediapipe
    },
    data() {
        return {
            ckRule: false,
            ckSubject: false,
            ckReuslt: false,
            answered: false,
            currentSub: 1,
            correctNum:0,
            // handsListens: ['okay', 'select'],
            subjectList: [],
            isCorrenct: false,
            isIncorrenct: false,
            currentIndex: 0,
            choiceAnswer: 5,
            choiceNum: 0,
            solution:true,
            ccurrentScreen: 'start',
            isCommplete:false,
            time:3000,
            select2:require("../static/select2.png"),
            select1:require("../static/select1.png"),
            timer:null,
            timerNum:0
        }
    },
    mounted() {
        this.getList()
        console.log(this.$refs)
    },
    computed: {
      handsListens() {
        if(this.ccurrentScreen === 'start'){
          return []
        }else if(this.ccurrentScreen === 'gameRule'){
          return ['okay']
        }else if(this.ccurrentScreen === 'ckSubject'){
          return []
        }
      },
      poseListens() {
        if(this.ccurrentScreen === 'start'){
          return []
        }else if(this.ccurrentScreen === 'gameRule'){
          return []
        }else if(this.ccurrentScreen === 'ckSubject'){
          if(this.answered === false){
            return ['right', 'wrong','select']
          }else if(this.answered === true){
            return ['back']
          }
        }
      }
    },
    methods: {
        finish(){
            this.isCommplete = true
        },
        change(timeData){
            this.time = timeData.seconds*1000 + timeData.milliseconds
        },
        correct() {
            this.answered = true
            this.isCorrenct = true
            this.correctNum = this.correctNum + 20
        },
        incorrect() {
            this.answered = true
            this.isIncorrenct = true
        },
        Correctjudge(answer, index) {
            if (index  !== answer && this.currentSub <= this.subjectList.length) {
                this.incorrect()
                this.solution = false
            } else if (index  == answer && this.currentSub <= this.subjectList.length) {

                this.correct()
                this.solution = true
            }
        },
        okay() {
            // Toast('Okay！')
          if(this.ccurrentScreen === 'gameRule'){
            this.ccurrentScreen = 'ckSubject'
          }
            // this.ckRule = false
            // this.ckSubject = true

        },
        right() {
            console.log("right");
            if (this.ccurrentScreen === 'ckSubject' && this.answered == false && this.subjectList[this.currentIndex].type == "judge") {
                this.Correctjudge(this.subjectList[this.currentIndex].answer, 1)
            }
        },
        wrong() {
            console.log("wrong");
            // this.handsListens = ['okay']
            // Toast('wrong！')
            if (this.ccurrentScreen === 'ckSubject' && this.answered == false && this.subjectList[this.currentIndex].type == "judge") {
                this.Correctjudge(this.subjectList[this.currentIndex].answer,0)
            }
        },
        select(index) {
            console.log(index)
            if (this.choiceAnswer == index && this.ccurrentScreen === 'ckSubject'&& this.subjectList[this.currentIndex].type == "select"&&  this.timerNum < 3) {
                //  this.$refs.countDown.start();
                 if(this.timer == null && this.timerNum < 3){
                    this.timer = setTimeout(()=>{
                        this.timerNum ++
                        clearTimeout(this.timer)
                        this.timer = null
                     },1000)
                    console.log("timernum",this.timerNum);
                 }
            } else if (this.choiceAnswer !== index && this.ccurrentScreen === 'ckSubject'&& this.subjectList[this.currentIndex].type == "select" ) {
                this.choiceAnswer = index
                this.timerNum = 0
                clearTimeout(this.timer)
                this.timer = null
                // this.$refs.countDown.reset();
            } else if (this.ccurrentScreen === 'ckSubject' && this.answered == false && this.subjectList[this.currentIndex].type == "select" &&  this.timerNum == 3) {
                this.Correctjudge(this.subjectList[this.currentIndex].answer, index)
                console.log("timernum",this.timerNum);
                // this.$refs.countDown.reset();
                this.isCommplete = false
                this.choiceAnswer = 5
                this.timerNum = 0
            }
        },
        back() {
            Toast('回退！')
            if (this.answered == true &&this.currentSub < this.subjectList.length ) {
                this.isCommplete = false
                // this.$refs.countDown.reset();
                this.answered = false
                this.isCorrenct = false
                this.isIncorrenct = false
                this.currentSub++
                this.choiceNum = 0
                this.choiceAnswer = 5
                this.timerNum = 0
                clearTimeout(this.timer)
                this.timer = null
                // this.$refs.progress.resize()
                this.$refs.swipe.next()
            } else if (this.currentSub >= this.subjectList.length) {

                this.ckSubject = false
                this.ckReuslt = true
            }
        },
        getList() {
            return getQuestionList().then(res => {
                this.subjectList = res.data
                console.log(this.subjectList.length)
            })
        },
        onChange(index) {
            this.currentIndex = index
        }
    }
}
</script>
<style scoped>

.home {
    width: 100vw;
    height: 100vh;
    box-sizing: border-box;
    background-color: rgba(255, 255, 255, 1);
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url('../static/mathBackground.png') no-repeat ;
    background-size: cover;
}

.content {
    width: 60%;
    margin-top: 30rem;

}

.gameRule {
    position: fixed;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index:102;
    background-color: rgba(0, 0, 0, 0.298);
    box-sizing: border-box;
}

.ruleDetail {
    width: 80%;
    height: 80%;
    border-radius: 15px;
    margin-top: 20%;
    margin-left: 10%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 15px;
    box-sizing: border-box;
    position: absolute;
    top: 0;
}

.Judge1 {
    width: 100%;
    height: 100%;
    background: url('../static/mathBackground.png') no-repeat ;
    background-size: cover;
    position: fixed;
    z-index: 102;
    top: 0;
    box-sizing: border-box;

}

.qqq {
    width: 100%;
    height: 100%;
    padding: 20px 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    position: relative;

}

.subjectNum {
    font-size: 5rem;
    font-weight: bold;
    text-align: center;
    margin-top: 2rem;
}

.subjectContent {
    width: 80%;
    height: 20rem;
    padding: 5rem 5rem;
    box-sizing: border-box;
    margin-top: 5rem;
    position: absolute;
    top: 12rem;
    left: 10%;
}

.subjectType {
    font-weight: bold;
    margin-bottom: 1rem;
    font-size: 3rem;
}

.subject {
    font-size: 3rem;
}

.option1 {
    display: flex;
    margin-top: 1rem;
    width: 100%;
    margin-left: 2rem;
    justify-content: space-around;
    margin-top: 2rem;
}

.reuslt {
    width: 100vw;
    height: 100vh;
    position: fixed;
    background: url('../static/mathBackground.png') no-repeat ;
    background-size: cover;
    top: 0;
    z-index: 102;
    padding: 5rem 5rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.reuslt_detail {
    width: 80%;
    height: 80%;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    position: absolute;
    top: 10%;
    left: 10%;
}

.selectOption {
    position: absolute;
    position: fixed;
    bottom: 12rem;
    z-index: 106;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width: 100%;
}
</style>
